import dayjs from 'dayjs';

import type { PhotoFilters } from './types';

export const SEARCH_DEBOUNCE_MS = 300;

export const createDefaultPhotoFilters = (now = new Date()): PhotoFilters => {
  const to = dayjs(now);
  return {
    states: ['ready'],
    uploadedFrom: to.subtract(7, 'day').format('YYYY-MM-DD'),
    uploadedTo: to.format('YYYY-MM-DD'),
  };
};

export const createPicOfDayPhotoFilters = (): PhotoFilters => ({
  states: ['approved'],
  excludeType: 'daily',
});

export const hasPhotoFilterRefinements = (filters: PhotoFilters): boolean =>
  Boolean(
    filters.category ||
      filters.type ||
      filters.themes?.length ||
      filters.tags?.length ||
      filters.search?.trim() ||
      filters.photographerId ||
      filters.uploadedFrom ||
      filters.uploadedTo,
  );
